<h2>Efetue o upload de um arquivo Shapefile compactado (.zip)</h2>

<div class="input-wrapper">
  <app-upload-shapefile
    [displayConfig]="{
      showTitle: false,
      showDescription: true,
      customDescription: ' ',
      titlePosition: 'above',
    }"
    (fileUploaded)="onFileUploaded($event)"
    (originalFileName)="onOriginalFileName($event)"
  ></app-upload-shapefile>
  @if (isValid() === false) {
    <mat-error>Atributos inválidos</mat-error>
  }
</div>
<hr />

<div class="button-group">
  <button mat-stroked-button color="primary" (click)="onCancel()">
    <mat-icon>arrow_back</mat-icon> Cancelar
  </button>
  <button
    mat-flat-button
    [disabled]="isLoading | async"
    color="primary"
    (click)="onSubmit()"
  >
    Solicitar

    @if (!(isLoading | async)) {
      <mat-icon>save</mat-icon>
    } @else {
      <mat-icon>
        <mat-spinner matIcon diameter="18"></mat-spinner>
      </mat-icon>
    }
  </button>
</div>
